<template>
  <div class="comment-detail">
    <div class="comment-header">
      <div class="comment-user-info">
        <img v-if="data.pic" :src="data.pic">
        <img v-else src="~/assets/img/anonymous.png" alt="">
        <span>{{ data.nickname }}</span>
      </div>
      <div class="comment-operator">
        <a @click="handleCommentLike(data.id)"><span><i class="ion-ios-heart"></i> 点赞({{ like_cnt || 0 }})</span></a>
        <a @click="reply_comment_visible = true"><span><i class="ion-android-textsms"></i> 回复</span></a>
        <a @click="dialogReportVisible = true"><span><i class="ion-android-warning" style="color: #FFC41C;"></i> 举报</span></a>
        <span>{{ data.time }}</span>
        <span class="floor">{{ parseInt(data.floor) > 0 ? "#" + data.floor : "" }}</span>
      </div>
    </div>


    <div class="comment-content" v-html="htmlDecodeByRegExp(data.content)">

    </div>
    <!-- 子评论 -->
    <div class="child-comment" v-if="data.children">
      <comment-detail :aid="aid" v-for="item in data.children" :data="item" :key="item.id"></comment-detail>
    </div>

    <el-dialog :modal="true" :lock-scroll="false" :modal-append-to-body="true" title="回复" :visible="reply_comment_visible" width="30%" @close="reply_comment_visible = false">
      <div class="reply-comment-box">
        <div class="reply-user-info">
          <img :src="userInfo.pic" width="50" height="50" v-if="userInfo.pic">
          <img src="~/assets/img/anonymous.png" alt="" width="50" height="50" v-else>
          <p v-if="isLogin">{{ userInfo.nick }}</p>
        </div>

        <div class="reply-comment-form">
          <div class="reply-username">
            <input v-model="reply_username" v-if="! isLogin" type="text" placeholder="请输入名字或匿名评论"></input>
          </div>

          <div class="reply-content">
            <textarea v-model="reply_content"></textarea>
          </div>

          <div class="reply-submit">
            <el-button size="small" @click="handleReplyComment">发送回复</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible="dialogReportVisible" @close="dialogReportVisible = false" title="举报信息" width="30%">
      <div style="text-align: right;">
        <textarea v-model="report_content" style="display: block;width: 100%;height: 200px;padding: 10px;"></textarea>
        <el-button size="mini" style="margin-top: 10px;" @click="handleArticleReport">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {commentLike, addComment, addReport} from "~/utils/api";
  import {SUCCESS} from "../utils/status-code";
  import { mapState } from 'vuex';
  import {successMsg, errorMsg, getDateStr} from "~/utils/tools";

  export default {
    name: "comment-detail",
    data() {
      return {
        like_cnt              : this.data.like_cnt,
        reply_comment_visible : false,
        reply_content         : "",
        reply_username        : "",
        report_content        : "",
        dialogReportVisible   : false
      }
    },
    props: {
      data: Object,
      aid: Number
    },
    mounted() {
    },

    computed: {
      ...mapState('auth', [
        'userInfo',
        'isLogin'
      ])
    },
    methods: {
      /**
       * html 解码.
       *
       * @param str
       * @returns {string}
       */
      htmlDecodeByRegExp:function (str){
        var s = "";
        if(str.length == 0) return "";
        s = str.replace(/&amp;/g,"&");
        s = s.replace(/&lt;/g,"<");
        s = s.replace(/&gt;/g,">");
        s = s.replace(/&nbsp;/g," ");
        s = s.replace(/&#39;/g,"\'");
        s = s.replace(/&quot;/g,"\"");
        return s;
      },

      /**
       * 点赞.
       *
       * @param id
       */
      handleCommentLike(id) {
        commentLike(id).then(res => {
          if (parseInt(res.errno) !== SUCCESS.code) {
            return false;
          }

          let like = (this.like_cnt === null || isNaN(this.like_cnt)) ? 0 : this.like_cnt;
          this.like_cnt = parseInt(like) + 1;
        });
      },

      /**
       * 消息回复.
       */
      handleReplyComment() {
        if (!this.reply_content.trim()) {
          errorMsg('请输入评论内容！');
          return;
        }

        let comment_id  = parseInt(this.data.id);
        let floor       = parseInt(this.data.floor) + 1;
        let source_id   = parseInt(parseInt(this.data.source_id) ? this.data.source_id : this.data.id);
        let nickname    = this.userInfo.nick;
        let data        = {
          comment_id: comment_id,
          aid       : this.aid,
          content   : this.reply_content,
          source_id : source_id,
          floor     : floor,
        };

        /**
         * 添加评论
         */
        addComment(data).then(res => {
          if (parseInt(res.errno) !== SUCCESS.code) {
            return false;
          }

          let new_child = {
            id        : res.data.id,
            comment_id: comment_id,
            content   : this.reply_content,
            floor     : floor,
            islike_cnt: 0,
            like_cnt  : 0,
            nickname  : nickname,
            pic       : this.userInfo.pic || null,
            source_id : source_id,
            time      : getDateStr(),
          };

          this.data.children ? this.data.children.unshift(new_child) : this.data.children = [new_child];

          // 清空数据，并隐藏弹出框
          this.reply_content          = "";
          this.reply_comment_visible  = false;
          successMsg("评论成功");
        });
      },
      /**
       * 举报文章.
       */
      handleArticleReport() {
        // type: 1 文章，2评论
        addReport(this.data.id, 2, this.report_content).then((res) => {
          successMsg("举报成功");
          this.dialogReportVisible = false;
          this.report_content = "";
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  /* 导入全局样式变量 */
  @import '~assets/stylus/variable.styl'

  .comment-detail {
    margin-bottom: 10px;
  }
  .comment-header{
    display: flex;

    .comment-user-info {
      text-align: center;
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .comment-operator {
      display: flex;
      flex: 1;
      text-align: right;
      align-items: center;
      justify-content: flex-end;

      span {
        padding: 0 5px;
      }
      a {
        cursor: pointer;
      }
      .floor {
        font-weight bold;
      }
    }
  }

  .comment-content {
    margin-top: 10px;
    padding-left: 20px;
  }
  .child-comment {
    margin: 10px 0 0 20px;
    border: 1px solid border_color_lv3;
    border-radius: 5px;
  }

  /* 回复 */
  .reply-comment-box {
    display: flex;
    flex-direction: row;
    .reply-user-info {
      text-align: center;
      margin-right: 10px;
      img {
        display: inline-block;
        border-radius: 50%;
      }
    }
    .reply-comment-form {
      flex: 1;
      text-align: right;
      input {
        width: 100%;
        margin-bottom: 10px;
        border: 1px solid border_color_lv3;
        outline: none;
        padding: 10px;
      }
      textarea {
        width: 100%;
        height: 100px;
        padding: 10px;
        border: 1px solid border_color_lv3;
      }
    }
  }
</style>
